import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const UPDATED = "Februari 2026";

function H2({ children }) {
  return (
    <h2 className="mt-10 mb-3 font-heading text-2xl font-extrabold text-[#1B2A1E]">
      {children}
    </h2>
  );
}

function P({ children }) {
  return (
    <p className="text-[#3a4338] text-base leading-relaxed mb-3">{children}</p>
  );
}

function Bullets({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1.5 mb-3 text-[#3a4338] leading-relaxed">
      {items.map((i, idx) => (
        <li key={idx}>{i}</li>
      ))}
    </ul>
  );
}

export default function Cookiepolicy() {
  return (
    <>
      <SEO
        title="Cookiepolicy | Trädfällarna Laholm AB"
        description="Information om cookies på Trädfällarna Laholm AB:s webbplats — vilka som används och varför."
        path="/cookiepolicy"
      />

      <section className="section-pad bg-[#F7F5F0]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="eyebrow">Information</span>
          <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold text-[#1B2A1E] leading-tight tracking-tight">
            Cookiepolicy
          </h1>
          <p className="mt-4 text-[#5A6258] text-sm">Senast uppdaterad: {UPDATED}</p>

          <div className="mt-8" data-testid="cookiepolicy-content">
            <H2>Vad är cookies?</H2>
            <P>
              Cookies är små textfiler som sparas i din webbläsare när du besöker
              en webbplats. De används för att webbplatsen ska fungera, för att
              komma ihåg dina val eller för att samla in statistik.
            </P>

            <H2>Cookies på den här webbplatsen</H2>
            <P>
              Vi försöker hålla användningen av cookies så låg och tydlig som
              möjligt. Webbplatsen använder i dag i första hand nödvändiga
              tekniska cookies — det vill säga sådana som krävs för att den ska
              fungera. Om vi i framtiden lägger till statistik- eller
              analysverktyg kommer informationen här att uppdateras.
            </P>

            <H2>Nödvändiga cookies</H2>
            <P>
              Nödvändiga cookies behövs för grundläggande funktioner som att
              bevara session, skydda mot missbruk av formulär och ge en säker
              upplevelse. Dessa cookies kräver inget samtycke eftersom
              webbplatsen inte kan fungera utan dem.
            </P>

            <H2>Statistik- och analyscookies</H2>
            <P>
              Den här webbplatsen aktiverar inte spårnings- eller marknadsförings­cookies som standard. Om webbplatsen senare börjar använda
              analysverktyg (t.ex. besöksstatistik) kommer du att informeras och
              få möjlighet att välja.
            </P>

            <H2>Inbäddat innehåll från externa tjänster</H2>
            <P>
              Vi använder ibland inbäddat innehåll från externa tjänster,
              exempelvis YouTube, Facebook, Instagram eller Google Maps. Sådana
              tjänster kan sätta egna cookies när innehållet laddas.
            </P>
            <P>
              För att skydda din integritet laddas externa videor och kartor{" "}
              <strong>inte automatiskt</strong>. Du ser först en placeholder med
              texten:
            </P>
            <P>
              <em>
                ”Den här videon laddas från en extern tjänst och kan använda
                cookies.”
              </em>
            </P>
            <P>
              När du klickar för att visa innehållet samtycker du till att den
              externa tjänsten kan sätta cookies enligt sina egna villkor. Vill
              du läsa mer om hur de hanterar uppgifter hänvisar vi till
              respektive tjänsts integritetspolicy.
            </P>

            <H2>Hur du hanterar cookies</H2>
            <Bullets
              items={[
                "Du kan när som helst ta bort cookies från din webbläsare via webbläsarens inställningar.",
                "Du kan ställa in webbläsaren så att den blockerar vissa eller alla cookies.",
                "Om du blockerar nödvändiga cookies kan vissa delar av webbplatsen sluta fungera korrekt.",
              ]}
            />

            <H2>Mer information</H2>
            <P>
              För information om hur vi hanterar personuppgifter, se vår{" "}
              <Link
                to="/integritetspolicy"
                className="text-[#D95D2E] hover:underline font-semibold"
                data-testid="cookie-link-integritetspolicy"
              >
                Integritetspolicy
              </Link>
              .
            </P>
          </div>
        </div>
      </section>
    </>
  );
}
